import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import ChangeIcon from 'components/ChangeIcon';

import { FlightPriceChangeIcon_entry$key } from '__generated__/FlightPriceChangeIcon_entry.graphql';

type Props = {
  entry: FlightPriceChangeIcon_entry$key;
};

const FlightPriceChangeIcon: FC<Props> = props => {
  const { priceChange } = useFragment(
    graphql`
      fragment FlightPriceChangeIcon_entry on FlightPrice {
        priceChange
      }
    `,
    props.entry
  );

  return <ChangeIcon change={priceChange} />;
};

export default FlightPriceChangeIcon;
